import React from "react";

export const Icon = () => (
  <svg
    width="25"
    height="18"
    viewBox="0 0 25 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
  >
    <line
      x1="0.625"
      y1="1.375"
      x2="24.375"
      y2="1.375"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <line
      x1="0.625"
      y1="9.375"
      x2="24.375"
      y2="9.375"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <line
      x1="0.625"
      y1="17.375"
      x2="24.375"
      y2="17.375"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);
